import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import LoginCard from './components/LoginCard';
import backgroundImage from '../../assets/images/gallerylarge.png';
import { Navigate } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import { AppContext } from '../../context/ContextProvider';

const BackgroundContainer = styled(Box)({
  width: '100%',
  height: '100%',
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
});
const BackgroundShadow = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  margin: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.54)',
});

const LoginPage = () => {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  useEffect(() => {
    if (isLogin) {
      setIsShow(true);
    }
  }, [isLogin, isShow]);

  return isLogin ? (
    <Navigate to="/" />
  ) : (
    <BackgroundContainer>
      <BackgroundShadow>
        <LoginCard />
      </BackgroundShadow>
    </BackgroundContainer>
  );
};

export default LoginPage;
